// Блок «Автор и дата обновления». Требование всех трех ТЗ: не «команда
// профессионалов», а конкретный человек — метрика Проксима учитывает
// авторитетность автора.
//
// Данные — в `mode.seoAuthor`:
//
//   seoAuthor: {
//     name: 'Имя Фамилия',
//     role: 'должность',
//     about: 'одно-два предложения про опыт',
//     photo: '/authors/name.jpg',   // необязательно
//     updated: '30.07.2026',        // дата последнего обновления материала
//   }
//
// Кто именно указывается автором — решение владельца, поэтому данных пока нет
// ни у одного режима, и блок просто не рендерится.

import "./SeoAuthor.scss";

export default function SeoAuthor({ author }) {
  if (!author || (!author.name && !author.updated)) return null;

  return (
    <section className="seo-author">
      {author.photo && (
        <img
          className="seo-author__photo"
          src={author.photo}
          alt={author.name || "Автор материала"}
          loading="lazy"
        />
      )}
      <div className="seo-author__text">
        {author.name && (
          <p className="seo-author__name">
            {author.name}
            {author.role && <span className="seo-author__role">, {author.role}</span>}
          </p>
        )}
        {author.about && <p className="seo-author__about">{author.about}</p>}
        {author.updated && (
          <p className="seo-author__updated">Материал обновлен: {author.updated}</p>
        )}
      </div>
    </section>
  );
}
